import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import * as VueGoogleMaps from 'vue2-google-maps'
import pagePropertiesMixin from './mixins/pagePropertiesMixin'
import VueGtag from "vue-gtag";
import axios from 'axios';

Vue.mixin(pagePropertiesMixin)

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { id: "G-J985KK6HSW" }
});

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDYT11FlrWoX4Ww7c8sctEnJrRr0FygxOA',
    libraries: 'places',
    mapi_id: '5ed5174e6f862352'
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
